import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Eye, ArrowRight } from "lucide-react";
import { news } from "../mock";
import { Reveal, PageHero } from "../components/Shared";
import useSEO from "../hooks/useSEO";

const Haberler = () => {
  useSEO({
    title: "Blog & Haberler",
    description:
      "Nikomedya Turizm'den güncel gelişmeler, kalite belgeleri, duyurular ve taşımacılık sektörüne dair bilgiler.",
  });

  return (
    <div>
      <PageHero
        title="Blog & Haberler"
        subtitle="Nikomedya Turizm'den güncel gelişmeler, duyurular ve sektöre dair bilgileri takip edin."
      />

      <section className="py-24 bg-[#f5f8fb]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((n, i) => (
              <Reveal key={n.id} delay={i * 100}>
                <Link
                  to={`/haberler/${n.id}`}
                  className="news-card group block h-full bg-white rounded-2xl overflow-hidden border border-slate-100"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={n.image}
                      alt={n.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#081f3b]/40 to-transparent" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-xs text-[#5b6b7d]">
                      <span className="flex items-center gap-1.5">
                        <CalendarDays size={13} className="text-[#1e9cd7]" />
                        {n.date}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <Eye size={13} className="text-[#1e9cd7]" />
                        {n.views} Görüntülenme
                      </span>
                    </div>
                    <h2 className="mt-3 text-lg font-bold text-[#0d2b4f] leading-snug group-hover:text-[#1e9cd7] transition-colors">
                      {n.title}
                    </h2>
                    <p className="mt-2.5 text-sm text-[#5b6b7d] leading-relaxed line-clamp-3">
                      {n.excerpt}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1e9cd7]">
                      Devamını Oku
                      <ArrowRight
                        size={15}
                        className="transition-transform duration-300 group-hover:translate-x-1.5"
                      />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Haberler;
